<template>
  <div>
    <div class="home">
      <div class="row row-one">
        <Credit
          v-for="(credit, index) in rowOne"
          :key="index"
          class="row-one_block"
          :class="`block-${index + 1}`"
          :credit="credit"
          @onCreditClick="handleCreditClick($event)"
        />
      </div>
      <div class="row row-two">
        <Credit
          v-for="(credit, index) in rowTwo"
          :key="index"
          class="row-two_block"
          :credit="credit"
          @onCreditClick="handleCreditClick($event)"
        />
      </div>
      <div class="row row-three">
        <Credit
          v-for="(credit, index) in rowThree"
          :key="index"
          class="row-three_block"
          :credit="credit"
          @onCreditClick="handleCreditClick($event)"
        />
      </div>
      <LogoTile />
      <AboutTile />

    </div>
    <div class="hidden-md-down">
      <template v-if="showYoutube">
        <YoutubeContainer
          :url="url"
          @close="showYoutube=false"
        />
      </template>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import HorizontalScroll from 'horizontal-scroll'
import Credit from '@/components/Credit'
import LogoTile from '@/components/LogoTile'
import LoadingTile from '@/components/LoadingTile'
import AboutTile from '@/components/AboutTile'
import YoutubeContainer from '@/components/YoutubeContainer'

export default {
  components: {
    Credit,
    LogoTile,
    AboutTile,
    YoutubeContainer
  },
  data () {
    return {
      loading: false,
      credits: [],
      rowOneLength: null,
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0.25, 0.75] // [0.25, 0.75] if you want a 25% offset!
      }, // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      showYoutube: false,
      url: ''
    }
  },
  async created () {
    const contentful = require('contentful')
    const SPACE_ID = process.env.VUE_APP_SPACE_ID
    const ACCESS_TOKEN = process.env.VUE_APP_CONTENT_DELIVERY

    try {
      const client = contentful.createClient({
        // This is the space ID. A space is like a project folder in Contentful terms
        space: SPACE_ID,
        // This is the access token for this space. Normally you get both ID and the token in the Contentful web app
        accessToken: ACCESS_TOKEN
      })
      const entries = await client.getEntries({
        content_type: 'credit',
        include: 2
      })

      this.credits = entries.items.map(credit => {
        return {
          ...credit.fields,
          artwork: credit.fields.artwork.fields.file.url
        }
      })
      this.credits.sort((a, b) => a.orderInRow - b.orderInRow)
      this.loading = false
    } catch (error) {
      this.loading = false
    }
  },
  mounted () {
    this.setViewHeight()
    window.addEventListener('resize', () => this.setViewHeight())
    const body = document.querySelector('body')
    body.setAttribute(
      'style',
      'overscroll-behavior-y: contain; position: fixed; overflow: hidden; background: black; overflow-y: hidden;'
    )
  },
  updated () {
    // Row One
    const rowOne = document.getElementsByClassName('row-one')
    const rowOneBlocks = document.getElementsByClassName('row-one_block')
    if (this.credits.length > 1) {
      const initialiseRowOne = new HorizontalScroll({
        blocks: rowOneBlocks,
        container: rowOne,
        isAnimated: true,
        springEffect: 0.8
      })
    }
    // Row Two
    const rowTwo = document.getElementsByClassName('row-two')
    const rowTwoBlocks = document.getElementsByClassName('row-two_block')
    if (this.credits.length > 1) {
      const initialiseRowTwo = new HorizontalScroll({
        blocks: rowTwoBlocks,
        container: rowTwo,
        isAnimated: true,
        springEffect: 0.8
      })
    }
    // Row Three
    const rowThree = document.getElementsByClassName('row-three')
    const rowThreeBlocks = document.getElementsByClassName('row-three_block')
    if (this.credits.length > 1) {
      const initialiseRowThree = new HorizontalScroll({
        blocks: rowThreeBlocks,
        container: rowThree,
        isAnimated: true,
        springEffect: 0.8
      })
    }
  },
  computed: {
    rowOne () {
      return [
        ...this.credits.filter(credit => credit.row === 1),
        ...this.credits.filter(credit => credit.row === 1),
        ...this.credits.filter(credit => credit.row === 1),
        ...this.credits.filter(credit => credit.row === 1),
        ...this.credits.filter(credit => credit.row === 1),
        ...this.credits.filter(credit => credit.row === 1)
      ]
    },
    rowTwo () {
      return [
        ...this.credits.filter(credit => credit.row === 2),
        ...this.credits.filter(credit => credit.row === 2),
        ...this.credits.filter(credit => credit.row === 2),
        ...this.credits.filter(credit => credit.row === 2),
        ...this.credits.filter(credit => credit.row === 2),
        ...this.credits.filter(credit => credit.row === 2)
      ]
    },
    rowThree () {
      return [
        ...this.credits.filter(credit => credit.row === 3),
        ...this.credits.filter(credit => credit.row === 3),
        ...this.credits.filter(credit => credit.row === 3),
        ...this.credits.filter(credit => credit.row === 3),
        ...this.credits.filter(credit => credit.row === 3),
        ...this.credits.filter(credit => credit.row === 3)
      ]
    }
  },
  methods: {
    handleCreditClick (url) {
      if (!url) return
      this.url = url
      this.showYoutube = true
    },
    setViewHeight () {
      const vh = window.innerHeight * 0.01
      console.log('vh ', vh)
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-out;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.hidden-md-down {
  display: none;
}

@media screen and (min-width: 815px) {
  .hidden-md-down {
    display: block;
  }
}
</style>
